import React from 'react';
import { AgingBucket } from 'services/reportsApi';
import { BucketCells } from './pivot';

interface Props {
  summary: BucketCells;
}

const PRIMARY_BUCKETS: AgingBucket[] = ['0-30', '31-60', '61-90', '90+'];

const fmtMoney = (n: number): string =>
  `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const BUCKET_STYLE: Record<AgingBucket, string> = {
  '0-30': 'border-green-300',
  '31-60': 'border-yellow-300',
  '61-90': 'border-orange-300',
  '90+': 'border-red-300',
  unmailed: 'border-gray-300',
};

export const CheckAgingStats: React.FC<Props> = ({ summary }) => {
  const tiles: AgingBucket[] = [...PRIMARY_BUCKETS];
  if (summary.unmailed.count > 0) tiles.push('unmailed');

  return (
    <div className="flex w-full flex-wrap gap-3 py-3">
      {tiles.map((bucket) => (
        <div
          key={bucket}
          className={`flex min-w-[180px] flex-1 flex-col rounded-lg border-l-4 bg-white p-4 shadow-analyticsCard ${BUCKET_STYLE[bucket]}`}
          data-testid={`stat-tile-${bucket}`}
        >
          <span className="text-12s uppercase tracking-wide text-gray-500">
            {bucket === 'unmailed' ? 'Not yet mailed' : `${bucket} days`}
          </span>
          <span className="mt-1 text-24s font-bold text-gray-900">{summary[bucket].count}</span>
          <span className="text-14s text-gray-600">{fmtMoney(summary[bucket].total_amount)}</span>
        </div>
      ))}
    </div>
  );
};

export default CheckAgingStats;
